import { Link } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';

function HelpIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

function TicketIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1a2 2 0 0 0 0 4v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 0 0-4Z" />
      <path d="M9 9v6" strokeDasharray="1.5 1.5" />
    </svg>
  );
}

function HistoryIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 3v6h6" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function Support() {
  const { settings } = useConfig();

  return (
    <>
      <div className="page-header">
        <h1>Support</h1>
      </div>
      <p className="muted">Need a hand, or found something that isn't working right?</p>

      <div>
        <div className="card">
          <div className="kpi-card-icon">
            <HelpIcon />
          </div>
          <h2>Help</h2>
          <p className="muted">What each part of the portal does.</p>
          <Link to="/help" className="btn btn-primary">
            Open Help
          </Link>
        </div>

        {settings.service_desk_url && (
          <div className="card">
            <div className="kpi-card-icon">
              <TicketIcon />
            </div>
            <h2>Raise a ticket</h2>
            <p className="muted">Submit and track a request on our service desk.</p>
            <a href={settings.service_desk_url} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Open Service Desk
            </a>
          </div>
        )}

        <div className="card">
          <div className="kpi-card-icon kpi-tone-success">
            <HistoryIcon />
          </div>
          <h2>Versions</h2>
          <p className="muted">See what's changed recently.</p>
          <Link to="/changelog" className="btn btn-primary">
            View Change Log
          </Link>
        </div>
      </div>
    </>
  );
}
